/**
 * BrandMark — T15: Unified brand logo component
 * Replaces all hardcoded "Y GO" text across the application.
 * Uses the official logo image with optional text fallback.
 */
import React from 'react';

const SIZES = {
  xs: { img: 'h-4', text: 'text-xs' },
  sm: { img: 'h-6', text: 'text-sm' },
  md: { img: 'h-8', text: 'text-base' },
  lg: { img: 'h-10', text: 'text-lg' },
  xl: { img: 'h-14', text: 'text-xl' },
  '2xl': { img: 'h-20', text: 'text-2xl' },
};

export function BrandMark({ size = 'md', className = '', showText = false }) {
  const s = SIZES[size] || SIZES.md;
  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`} data-testid="brand-mark">
      <img src="/ygo-logo.png" alt="Y GO" className={`${s.img} w-auto object-contain`} />
      {showText && <span className={`font-bold text-[#C9A24D] tracking-wide ${s.text}`}>Y GO</span>}
    </span>
  );
}

export default BrandMark;
